export default "__VITE_ASSET__GeczG5po__"